import { AfterViewInit, Directive, ElementRef, inject, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appCustomLink]',
  standalone: true
})
/**
 * Die `HtmlInputDirective` passt das Erscheinungsbild von Nachrichten an, indem sie:
 * - Den vertikalen Abstand von `<p>`-Elementen minimiert.
 * - Die Links innerhalb der Nachricht einheitlich stylt und Hover-Effekte hinzufügt.
 *
 * Diese Directive wird verwendet, um sicherzustellen, dass die Nachricht konsistent
 * und benutzerfreundlich dargestellt wird.
 * Begründung: Aus UI/UX Gründen wurde das Directive erstellt
 */
export class HtmlInputDirective implements AfterViewInit, OnDestroy {
  private observer?: MutationObserver;
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  constructor() {}

  ngAfterViewInit() {
    this.reduceParagraphSpacing();
    this.styleLinks();
    this.observeDomChanges();
  }

  private reduceParagraphSpacing(): void {
    const paragraphs = this.el.nativeElement.querySelectorAll('p');
    paragraphs.forEach((p: HTMLElement) => {
      this.renderer.setStyle(p, 'margin-top', '0');
      this.renderer.setStyle(p, 'margin-bottom', '0');
    });
  }

  private styleLinks(): void {
    const links = this.el.nativeElement.querySelectorAll('a');
    links.forEach((link: HTMLElement) => {
      this.setLinkStyles(link);
    });
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private setLinkStyles(link: HTMLElement): void {
    this.renderer.setStyle(link, 'color', 'blue');
    this.renderer.setStyle(link, 'text-decoration', 'none');

    this.renderer.listen(link, 'mouseover', () => {
      this.renderer.setStyle(link, 'color', 'darkblue');
    });

    this.renderer.listen(link, 'mouseout', () => {
      this.renderer.setStyle(link, 'color', 'blue');
    });
  }

  private observeDomChanges(): void {
    this.observer = new MutationObserver(() => {
      this.reduceParagraphSpacing();
      this.styleLinks();
    });

    this.observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true
    });
  }
}
